(function () {
  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizePostcode(value) {
    return normalizeText(value).replace(/\s+/g, '').toUpperCase();
  }

  function setFeedback(node, message, state) {
    if (!node) return;
    node.hidden = !message;
    node.textContent = message || '';
    node.classList.remove('is-error', 'is-success');
    if (message && state) {
      node.classList.add(state === 'error' ? 'is-error' : 'is-success');
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function setText(root, selector, value, { hideCardSelector } = {}) {
    const node = root.querySelector(selector);
    if (!node) return;

    const card = hideCardSelector ? root.querySelector(hideCardSelector) : null;
    const hasValue = Boolean(value);

    node.textContent = value || '';
    if (card) {
      card.hidden = !hasValue;
    } else {
      node.hidden = !hasValue;
    }
  }

  function setLink(root, selector, config, { hideCardSelector } = {}) {
    const node = root.querySelector(selector);
    if (!node) return;

    const card = hideCardSelector ? root.querySelector(hideCardSelector) : null;
    const hasValue = Boolean(config && config.href && config.label);

    if (hasValue) {
      node.href = config.href;
      node.textContent = config.label;
      node.hidden = false;
    } else {
      node.removeAttribute('href');
      node.textContent = '';
      node.hidden = true;
    }

    if (card) {
      card.hidden = !hasValue;
    }
  }

  function detectCarrierKey(tracking) {
    const carrierText = [
      tracking.localProvider,
      tracking.primaryCarrierName,
      tracking.company,
    ]
      .map(normalizeText)
      .join(' ')
      .toLowerCase();

    if (carrierText.includes('postnl')) return 'postnl';
    if (carrierText.includes('dhl')) return 'dhl';
    if (carrierText.includes('gofo')) return 'gofo';
    if (carrierText.includes('bpost')) return 'bpost';
    return '';
  }

  function buildCarrierTrackingUrl(carrierKey, tracking, order) {
    const postcode = normalizePostcode(order?.shippingAddress?.zip || '');
    const primaryNumber = normalizeText(tracking.trackingNumber);
    const localNumber = normalizeText(tracking.localNumber);

    if (carrierKey === 'dhl') {
      const number = localNumber || primaryNumber;
      if (!number || !postcode) return '';
      return `https://www.dhlparcel.nl/nl/volg-uw-zending-0?tt=${encodeURIComponent(number)}&pc=${encodeURIComponent(postcode)}`;
    }

    if (carrierKey === 'postnl') {
      const number = localNumber || primaryNumber;
      if (!number) return '';
      const params = new URLSearchParams({
        B: number,
        D: 'NL',
        T: 'C',
      });
      if (postcode) {
        params.set('P', postcode);
      }
      return `https://postnl.nl/tracktrace/?${params.toString()}`;
    }

    if (carrierKey === 'gofo') {
      const number = localNumber || primaryNumber;
      if (!number) return '';
      return `https://www.gofo.com/nl/en/tracking-results/?id=${encodeURIComponent(number)}`;
    }

    if (carrierKey === 'bpost') {
      return 'https://www.bpost.be/track';
    }

    return normalizeText(tracking.url);
  }

  function highlightPartner(root, carrierKey) {
    root.querySelectorAll('[data-owa-partner]').forEach((node) => {
      node.classList.toggle('is-active', carrierKey && node.dataset.owaPartner === carrierKey);
    });
  }

  function buildActionConfig(tracking, order) {
    const carrierKey = detectCarrierKey(tracking);
    const actionUrl = buildCarrierTrackingUrl(carrierKey, tracking, order);
    const pickupLocationValue = normalizeText(tracking.pickupLocation || tracking.latestEventLocation);
    const pickupLocation =
      pickupLocationValue && !['NL', 'NETHERLANDS'].includes(pickupLocationValue.toUpperCase())
        ? pickupLocationValue
        : '';

    if (tracking.statusKey === 'pickup_ready') {
      return {
        carrierKey,
        eyebrow: 'Actie nodig',
        title: 'Je pakket moet worden opgehaald',
        copy: pickupLocation
          ? 'Je pakket ligt klaar bij een afhaalpunt. Haal het op binnen de bewaartermijn van de vervoerder.'
          : 'Je pakket ligt klaar bij een afhaalpunt. Open de vervoerderspagina hieronder om het exacte afhaalpunt en de bewaartermijn te bekijken.',
        location: pickupLocation ? `Afhalen bij: ${pickupLocation}` : '',
        button: actionUrl
          ? {
              href: actionUrl,
              label: 'Bekijk afhaalpunt',
            }
          : null,
      };
    }

    if (tracking.statusKey === 'delivery_attempt_failed') {
      return {
        carrierKey,
        eyebrow: 'Actie nodig',
        title: 'Controleer de nieuwe bezorgupdate',
        copy: 'De bezorger kon het pakket nog niet afleveren. Op de vervoerderspagina zie je of er een nieuwe bezorgpoging komt of dat het pakket naar een afhaalpunt gaat.',
        location: '',
        button: actionUrl
          ? {
              href: actionUrl,
              label: 'Volg jouw bestelling',
            }
          : null,
      };
    }

    return {
      carrierKey,
      eyebrow: '',
      title: '',
      copy: '',
      location: '',
      button: null,
    };
  }

  function renderTimeline(root, timeline) {
    const shell = root.querySelector('[data-owa-timeline-shell]');
    const container = root.querySelector('[data-owa-timeline]');
    if (!shell || !container) return;

    if (!Array.isArray(timeline) || !timeline.length) {
      shell.hidden = true;
      container.innerHTML = '';
      return;
    }

    container.innerHTML = timeline
      .map((item) => {
        const dateLabel = escapeHtml(item.dateLabel || '');
        const description = escapeHtml(item.description || '');
        const location = escapeHtml(item.location || '');

        return `
          <article class="owa-order-tracking__timeline-item">
            <span class="owa-order-tracking__timeline-date">${dateLabel}</span>
            <strong class="owa-order-tracking__timeline-text">${description}</strong>
            ${location ? `<span class="owa-order-tracking__timeline-location">${location}</span>` : ''}
          </article>
        `;
      })
      .join('');

    shell.hidden = false;
  }

  function closeTrackingModal(root, { returnFocus = true } = {}) {
    const modal = root.querySelector('[data-owa-tracking-modal]');
    if (!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    if (returnFocus && root._owaTrackingModalOpener && typeof root._owaTrackingModalOpener.focus === 'function') {
      root._owaTrackingModalOpener.focus();
    }

    root._owaTrackingModalOpener = null;
  }

  function openTrackingModal(root, href, opener) {
    const modal = root.querySelector('[data-owa-tracking-modal]');
    const dialog = root.querySelector('[data-owa-tracking-modal-dialog]');
    const confirm = root.querySelector('[data-owa-tracking-modal-confirm]');

    if (!href) return;

    if (!modal || !dialog || !confirm) {
      window.open(href, '_blank', 'noopener');
      return;
    }

    confirm.href = href;
    confirm.hidden = false;
    root._owaTrackingModalOpener = opener || null;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    window.requestAnimationFrame(() => {
      dialog.focus();
    });
  }

  function renderResult(root, payload) {
    const order = payload.order || {};
    const tracking = payload.tracking || {};
    const hasLastMile = Boolean(tracking.localProvider || tracking.localNumber);
    const carrierKey = detectCarrierKey(tracking);
    const carrierTrackingUrl = buildCarrierTrackingUrl(carrierKey, tracking, order);
    const statusCard = root.querySelector('[data-owa-status-card]');
    const preFulfillmentNote = root.querySelector('[data-owa-pre-fulfillment-note]');

    setText(root, '[data-owa-tracking-status-eyebrow]', '');
    setText(root, '[data-owa-tracking-status-title]', '');
    setText(root, '[data-owa-tracking-status-body]', '');
    setText(root, '[data-owa-tracking-eta]', tracking.etaText || '');
    setText(root, '[data-owa-tracking-last-update]', tracking.latestEventDateLabel ? `Laatste update: ${tracking.latestEventDateLabel}` : '');

    if (statusCard) {
      statusCard.hidden = !(tracking.etaText || tracking.latestEventDateLabel);
    }

    if (preFulfillmentNote) {
      preFulfillmentNote.hidden = tracking.statusKey !== 'pre_fulfillment';
    }

    setText(root, '[data-owa-meta-order]', order.name || '', {
      hideCardSelector: '[data-owa-meta-order-card]',
    });
    setText(root, '[data-owa-meta-tracking]', tracking.trackingNumber || '', {
      hideCardSelector: '[data-owa-meta-tracking-card]',
    });
    setText(root, '[data-owa-meta-provider]', '', {
      hideCardSelector: '[data-owa-meta-provider-card]',
    });
    setText(root, '[data-owa-meta-last-mile]', tracking.localNumber || '', {
      hideCardSelector: '[data-owa-meta-last-mile-card]',
    });
    setLink(
      root,
      '[data-owa-meta-last-mile-link]',
      hasLastMile && carrierTrackingUrl
        ? {
            href: carrierTrackingUrl,
            label: 'Volg jouw bestelling',
          }
        : null,
      {
        hideCardSelector: '[data-owa-meta-last-mile-link-wrap]',
      }
    );

    highlightPartner(root, carrierKey);
    renderTimeline(root, tracking.timeline || []);

    const result = root.querySelector('[data-owa-tracking-result]');
    if (result) {
      result.hidden = false;
    }
  }

  async function submitLookup(root) {
    const endpoint = root.dataset.owaEndpoint || '';
    const orderNumber = root.querySelector('[data-owa-tracking-order-number]')?.value || '';
    const postcode = root.querySelector('[data-owa-tracking-postcode]')?.value || '';
    const houseNumber = root.querySelector('[data-owa-tracking-house-number]')?.value || '';
    const feedback = root.querySelector('[data-owa-tracking-feedback]');
    const result = root.querySelector('[data-owa-tracking-result]');
    const button = root.querySelector('[data-owa-tracking-submit]');

    if (!endpoint) {
      setFeedback(feedback, 'De trackingservice is nog niet gekoppeld aan deze pagina.', 'error');
      return;
    }

    if (!orderNumber || !postcode || !houseNumber) {
      setFeedback(feedback, 'Vul eerst je bestelnummer, postcode en huisnummer in.', 'error');
      return;
    }

    if (result) {
      result.hidden = true;
    }

    button.disabled = true;
    setFeedback(feedback, 'We halen je actuele trackingstatus op...', null);

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          orderNumber,
          postcode,
          houseNumber,
        }),
      });

      const data = await response.json();
      if (!response.ok || !data.ok) {
        throw new Error(data.message || 'Er ging iets mis bij het ophalen van je trackingstatus.');
      }

      renderResult(root, data);
      setFeedback(feedback, 'Trackingstatus bijgewerkt.', 'success');
    } catch (error) {
      setFeedback(
        feedback,
        error instanceof Error ? error.message : 'Er ging iets mis bij het ophalen van je trackingstatus.',
        'error'
      );
    } finally {
      button.disabled = false;
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.owaOrderTrackingReady === 'true') return;
    root.dataset.owaOrderTrackingReady = 'true';

    const button = root.querySelector('[data-owa-tracking-submit]');
    const modal = root.querySelector('[data-owa-tracking-modal]');
    const confirm = root.querySelector('[data-owa-tracking-modal-confirm]');
    const lastMileLink = root.querySelector('[data-owa-meta-last-mile-link]');
    if (button) {
      button.addEventListener('click', function () {
        submitLookup(root);
      });
    }

    if (lastMileLink) {
      lastMileLink.addEventListener('click', function (event) {
        const href = this.getAttribute('href');
        if (!href) return;
        event.preventDefault();
        openTrackingModal(root, href, this);
      });
    }

    if (confirm) {
      confirm.addEventListener('click', function () {
        closeTrackingModal(root, { returnFocus: false });
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target.matches('[data-owa-tracking-modal-close]')) {
          closeTrackingModal(root);
        }
      });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeTrackingModal(root);
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-owa-order-tracking-root]').forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
